/**
 * Layout: Theme
 * -----------------------------------------------------------------------------
 * Entry file for all global theme scripts.
 *
 */
import '@/layout/theme.scss'

import AppHandler from '~/core/app-handler'
import Canvas from '~/core/canvas'
import Commands from '~/core/commands'
import EventBus from '~/core/event-bus'
import { focus, reportError, sleep } from '~/core/global-functions'
import Query from '~/core/query'
import Quicklink from '~/core/quicklink'
import { domReady } from '~/core/runners'
import StaticSectionAnalytics from '~/core/static-section-analytics'
import TagHandler from '~/core/tag-handler'

/**
 * Global Canvas variables.
 */
window.cnvs = window.cnvs || {}
window.cnvs.started = false

/**
 * Global Canvas functions.
 */
window.cnvs.EventBus = EventBus()
window.cnvs.Helpers = Commands().cli()
window.cnvs.Query = (query, useCache = true) => Query(query, useCache)

window.cnvs.Focus = focus
window.cnvs.ReportError = reportError
window.cnvs.Sleep = sleep

/**
 * DOM ready.
 */
domReady(() => {
  Commands().init()

  AppHandler().beforeVueInit()
  TagHandler().init()
  Canvas().init()
  AppHandler().afterVueInit()

  Quicklink().init()

  StaticSectionAnalytics().init()
})
